<template>
  <div class="w-full">
      <cabecera-web></cabecera-web>
      <formulario-altas></formulario-altas>
  </div>  
</template>
<script>
import FormularioAltas from '@/components/FormularioAltas'
// import FormularioAltas from '@/components/FormularioAltaDenda'
import CabeceraWeb from "@/components/Cabecera"
export default {
  components: {
    FormularioAltas,
    CabeceraWeb
  }
}
</script>